import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {NzNotificationService} from "ng-zorro-antd/notification";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {SILENT_ERRORS} from "../http-context.tokens";
import {AuthApiService} from "../services/auth-api.service";

export const httpHandlerInterceptor: HttpInterceptorFn = (req, next) => {

  if (req.url.includes('assets/i18n')) {
    return next(req);
  }

  const notification = inject(NzNotificationService);
  const translate = inject(TranslateService);
  const router = inject(Router);
  const authApi = inject(AuthApiService);

  const t = (key: string): string => translate.instant(`http.${key}`);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (req.context.get(SILENT_ERRORS)) {
        return throwError(() => error);
      }
      switch (error.status) {
        case 400:
          notification.error(t('validationTitle'), error.error?.error ?? t('failed'));
          break;
        case 401:
          notification.error(t('sessionExpiredTitle'), error.error?.error ?? t('sessionExpiredDesc'));
          authApi.clearLocal();
          void router.navigate(['/login']);
          break;
        case 429:
          notification.error(t('tooManyTitle'), t('tooManyDesc'));
          break;
        case 500:
          notification.error(t('serverTitle'), t('serverDesc'));
          break;
        case 502:
          notification.error(t('unavailableTitle'), t('unavailableDesc'));
          break;
        default:
          notification.error(t('errorTitle'), error.error?.error ?? t('failed'));
          break;
      }
      return throwError(() => error);
    })
  )
};
